export default __webpack_public_path__ + "static/media/Home.b936833b.jpg";